// De standaardactiviteiten. ENIGE BRON: public/gameon_activiteiten.md (een pure Markdown-tabel, wordt hier geparsed).
//
// Regels voor het bewerken van de md:
// - Voeg nieuwe rijen ALTIJD ONDERAAN toe. Id's volgen de rijvolgorde (1, 2, 3, ...); wie rijen invoegt of
//   verwijdert, verschuift id's en daarmee favorieten en verborgen activiteiten.
// - Houd het bestand een pure tabel (geen extra tabellen of kopregels met een |).
// - Elke wijziging verandert DEFAULTS_HASH; een niet-aangepaste lijst wordt bij de volgende start vernieuwd
//   (scores blijven op naam behouden). Een aangepaste lijst blijft ongemoeid.
import md from '../../public/gameon_activiteiten.md?raw';
import { parseMarkdownTable, sanitizeActivityList } from './activities';
import type { Activity } from './types';

/** Stabiele FNV-1a (32 bit) hash als hex-tekst. */
export function hashText(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

/** Hash van de md-tekst (regeleindes genormaliseerd, zodat Windows/Unix dezelfde hash geven). */
export const DEFAULTS_HASH: string = hashText(md.replace(/\r\n/g, '\n'));

export const DEFAULT_ACTIVITIES: Activity[] = sanitizeActivityList(
  parseMarkdownTable(md).map((a) => ({ ...a, id: null })),
);
